import { render, staticRenderFns } from "./faq-vital.vue?vue&type=template&id=926cd15e&scoped=true&"
import script from "./faq-vital.vue?vue&type=script&lang=js&"
export * from "./faq-vital.vue?vue&type=script&lang=js&"
import style0 from "./faq-vital.vue?vue&type=style&index=0&id=926cd15e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926cd15e",
  null
  
)

export default component.exports